import Loadable from '../../components/loadable';

const EditConsentClause = Loadable({
  loader: () => import('react/pages/privacy_policies/edit_consent_clause'),
});

angular.module('gym').value('EditConsentClause', EditConsentClause);
